export default {
  setShipmentConfirmPackings(state, payload) {
    state.shipmentConfirmPackings = payload;
  },
  setSearchConditions(state, payload) {
    state.searchConditions = payload;
  },
};
